import firebase from 'firebase/compat/app';
import "firebase/compat/database";
import 'firebase/compat/auth';


const firebaseConfig = {
    apiKey: "AIzaSyDDi2lt-4oDChpjMZEsysHZW40FnktTe7g",
    authDomain: "barcode-alias.firebaseapp.com",
    databaseURL: "https://barcode-alias-default-rtdb.firebaseio.com",
    projectId: "barcode-alias",
    storageBucket: "barcode-alias.appspot.com",
    messagingSenderId: "1076149317304",
    appId: "1:1076149317304:web:e19f8c7c661d92926e0e4d",
    measurementId: "G-XM67G0X49W"
};

firebase.initializeApp(firebaseConfig)
export const auth = firebase.auth()
export default firebase


